
import { defineComponent } from "vue";

export default defineComponent({
  name: "MediaComponent",
  computed: {
    images() {
      return [
        "Balance",
        "BalanceGraph",
        "Calculator",
        "Farms",
        "Home",
        "Missions",
        "Stats",
        "Storage",
        "Vehicles",
      ];
    },
  },
});
